var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.134 28.846 7.142-27.613c.251-.934-.71-1.612-1.47-.998L8.352 23.231c-.632.51-.367 1.273.432 1.487l19.863 5.514c1.09.291 2.203-.33 2.487-1.386Z",
    fill: "#985184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.867 21.153-7.143 27.613c-.25.934.71 1.612 1.47.998l28.455-22.997c.631-.51.367-1.272-.433-1.486l-19.862-5.514c-1.09-.291-2.203.329-2.487 1.386Z",
    fill: "#FBB945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32.67 22.908-1.535 5.937c-.284 1.057-1.398 1.677-2.487 1.386L17.332 27.09l1.536-5.937c.284-1.057 1.397-1.677 2.486-1.386l11.316 3.141Z",
    fill: "#F9464C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldService);
export default __webpack_public_path__ + "static/media/Field Service.c11ca4f9767e71cb7ca4d95d26abdd54.svg";
export { ForwardRef as ReactComponent };